<div class="p-2">
    <app-main-table [tableConfig]="tableConfig" *ngIf="tableConfig">
    </app-main-table>
</div>
